const Error = (props) => (
    <div className={`alert alert-danger ${props.message ? "display:block" : "hidden"}`} role="alert">{props.message}</div>
)

export default Error;